import logoSrc from "@/assets/favicon_io/android-chrome-192x192.png";

type PartzyncLogoProps = React.ComponentProps<"img"> & {
  size?: number;
};

export function PartzyncLogo({ className, size, ...props }: PartzyncLogoProps) {
  return (
    <img
      src={logoSrc}
      alt="PARTZYNC"
      width={size ?? 32}
      height={size ?? 32}
      className={`shrink-0 object-contain ${className ?? ""}`}
      {...props}
    />
  );
}
